export const ELIGIBILITY_CONFIG = {
    ELIGIBLE: {
        label: "Eligible",
        color: "#1E3A8A", bg: "#EFF6FF", border: "#BFDBFE", dot: "#2563EB",
        iconName: "solar:shield-check-bold",
    },

    NOTELIGIBLE: {
        label: "Not Eligible",
        color: "#ffffff",
        bg: "#827c78",
        border: "#6b6560",
        dot: "#a09a96",
        iconName: "solar:shield-check-bold",
    }
}
